<script>
  import { createEventDispatcher } from "svelte";
  import classNames from "../../utils/classNames";
  import CustomIcon from "../CustomIcon.svelte";

  export let disabled;
  const dispatch = createEventDispatcher();

  function handleDelete() {
    dispatch("delete");
  }
</script>

<div class="w-64 flex justify-end">
  <button
    on:click={handleDelete}
    {disabled}
    class={classNames(
      "inline-flex items-center px-4 py-2 rounded-md text-sm font-medium",
      disabled
        ? "border border-gray-200 bg-gray-50 text-gray-200"
        : "border-0 bg-custom-orange text-white"
    )}
  >
    <CustomIcon
      name="dlt"
      label="Delete"
      color="red"
      class="h-5 w-5 xl:hidden"
    />
    <span class="hidden xl:inline-block">Delete Selected</span>
  </button>
</div>
